import checkIfItemIsInView from "./checkIfItemIsInView";

/**
 * Returns true if at least one of the DOM Elements with the passed IDs are visible on the viewport
 * @param itemsDOMIds Lisf of DOM IDs
 */
var isOneOfThemInViewport = function isOneOfThemInViewport(itemsDOMIds) {
  var itemIsInView = itemsDOMIds.some(function (domId) {
    return checkIfItemIsInView(document.getElementById(domId));
  });
  return itemIsInView;
};
export default isOneOfThemInViewport;